export default "/articles/@slug";
